// extracted by mini-css-extract-plugin
export default {"teamContainer":"Team_teamContainer__Y5eQr","memberContainer":"Team_memberContainer__1dl5L","teamMember":"Team_teamMember__8yBqO"};